import { useState } from 'react';
import Lightbox, { Slide } from 'yet-another-react-lightbox';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import Download from 'yet-another-react-lightbox/plugins/download';
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Video from 'yet-another-react-lightbox/plugins/video';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import Thumbnail from '../Thumbnail/Thumbnail.component';

import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import 'yet-another-react-lightbox/styles.css';
import { useMessageBarContext } from '../../MessageBar.hook.ts';
import {
  isDocument,
  isPdf,
  isVideoOrAudio,
} from '../Thumbnail/Thumbnail.functions';
export default function Assets() {
  const { chatAttachments } = useMessageBarContext();
  const [openLightbox, setOpenLightbox] = useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!chatAttachments.length) {
    return null;
  }

  let attachments = chatAttachments;

  if (attachments.length > 5) {
    attachments = attachments.slice(0, 15);
  }

  const slideAttachments = attachments.filter((attachment) => {
    return !isDocument(attachment.type) && !isPdf(attachment.type);
  });

  const slides = slideAttachments.map((attachment) => {
    let output: Slide = {
      src: attachment.src,
      alt: attachment.name,
      title: attachment.name,
      description: attachment.type,
    };

    if (isVideoOrAudio(attachment.type)) {
      output = {
        type: 'video',
        autoPlay: true,
        poster: attachment.poster,
        sources: [
          {
            src: attachment.src,
            type: attachment.type,
          },
        ],
      };
    }

    return output;
  });

  function onClickThumbnail(index: number) {
    setCurrentIndex(index);
    setOpenLightbox(true);
  }

  function onCloseLightbox() {
    setOpenLightbox(false);
  }

  return (
    <div className="Assets w-full overflow-hidden">
      <div
        className="flex justify-start items-center gap-3 pt-2 overflow-x-auto w-full"
      >
        {attachments.map((attachment, index) => (
          <Thumbnail
            key={index}
            index={index}
            attachment={attachment}
            onClickThumbnail={onClickThumbnail}
          />
        ))}
      </div>

      {openLightbox && (
        <Lightbox
          plugins={[Zoom, Captions, Thumbnails, Download, Fullscreen, Video]}
          open={openLightbox}
          close={onCloseLightbox}
          slides={slides}
          index={currentIndex}
        />
      )}
    </div>
  );
}
